module.exports = __webpack_public_path__ + "img/lize02.a53fd15e.png";